<template>
  <div class="columns is-multiline">
    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <FormBrand v-model="element.brand"/>
    </div>
    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <FormModel v-model="element.model"/>
    </div>
    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputSelect
        name="Tipologia"
        v-model="element.type"
        :options="['Sola estrazione', ' Flusso doppio con recupero tramite scambiatore a flussi incrociati', ' Flusso doppio con recupero termodinamico', 'Altro']"
      />
    </div>

    <div class="column is-12-mobile is-6-tablet is-4-desktop" v-if="element.type === 'Altro'">
      <InputTextarea name="Descrizione altra tipologia" v-model="element.type_description" />
    </div>

    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputText name="Massima portata aria (m3/h)" v-model="element.air_flow" />
    </div>
    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputText name="Rendimento di recupero / COP" v-model="element.performance" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    element: Object
  }
}
</script>